function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 0.5,
  width: 56,
  height: 56,
  rx: 28,
  fill: "#BFD7FF"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_982_54202)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.0003 15.167C20.6403 15.167 14.667 21.1403 14.667 28.5003C14.667 35.8603 20.6403 41.8337 28.0003 41.8337C35.3603 41.8337 41.3337 35.8603 41.3337 28.5003C41.3337 21.1403 35.3603 15.167 28.0003 15.167ZM28.0003 39.167C22.1203 39.167 17.3337 34.3803 17.3337 28.5003C17.3337 22.6203 22.1203 17.8337 28.0003 17.8337C33.8803 17.8337 38.667 22.6203 38.667 28.5003C38.667 34.3803 33.8803 39.167 28.0003 39.167ZM34.1203 22.607L25.3337 31.3937L21.8803 27.9537L20.0003 29.8337L25.3337 35.167L36.0003 24.5003L34.1203 22.607Z",
  fill: "currentColor"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_982_54202"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "white",
  transform: "translate(12 12.5)"
})));

function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/SuccessIcon.5eee38d7.svg";
export { ForwardRef as ReactComponent };